import React, { useEffect, useRef, useState } from 'react';
import InputMask from 'react-input-mask';
import { InputNumberProps } from './InputNumberProps'
import { numberToDisplayString } from '../../../../common/helpers/number.helpers'
import { InputModes } from '../../../../models/form/IFieldsDefinition'


const InputNumber = React.memo((props: InputNumberProps) => {
   const { htmlInputType, field, debounceTime, value, handleSaveInputValueToStateAndValid } = props
   const defaultMaxLength = 50
   const hasPageBeenRendered = useRef(false)
   const [currentInputValue, setCurrentInputValue] = useState<number>(value as number)
   const [inputClear, setInputClear] = useState(true) //Hack używany do czyszczenia wartości kontrolki, w momencie zmiany typu dochodu na inny 



   // =============================== USE EFFECT'S ===============================

   useEffect(() => { // Czyszczenie wartości z kontrolki przy zmianie na inny typ dochodu
      setCurrentInputValue(props.value)
      setInputClear(false)
   }, [props.value])

   useEffect(() => { //Debounce input
       const timeoutId = setTimeout(() => {
          if(hasPageBeenRendered.current && inputClear){ //Pierwsze błedy walidacyjne wyświetlamy dopiero gdy użytkownik zacznie uzupełniać kontrolki
             handleSaveInputValueToStateAndValid(currentInputValue)
             return
          }
 
          hasPageBeenRendered.current = true // Pierwszy render strony - nie chcemy od razu wyświetlać wszystkich błędów walidacyjnych
       }, debounceTime)
 
       return () => clearTimeout(timeoutId)
 
     // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentInputValue, hasPageBeenRendered])

   // ==========================================================================



   // =============================== HANDLERS ===============================
   
   const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      const forbidenChars = [".", ",", "+", "-", "e"] //Wartość pola ma być liczbą naturalną, więc nie pozwalamy używać przecinka, kropki, ani minusa
      forbidenChars.includes(e.key) && e.preventDefault() //Blokuje możliwość wpisania danej wartości do kontrolki  
   } 

   const handleOnInputChange = (currentValue: string | undefined) => {
      if(currentValue === undefined || currentValue.startsWith('0')){
         return
      }
      
      const parsedValue = currentValue.replace(/[^0-9]/g, "")

      setCurrentInputValue(parseFloat(parsedValue))
      setInputClear(true)
   }

   // ==========================================================================

   return (
      <InputMask
         id={field.name}
         name={field.name}
         inputMode={InputModes.numeric}
         value={numberToDisplayString(currentInputValue, "", true)}
         mask={field.mask || ''} 
         maskChar={''}
         maxLength={!field.mask ? ( field.maxLength ?? defaultMaxLength ) : undefined}  //Jeśli jest maska ona określa ile znaków można wpisać w kontrolkę. Jeśli nie ma maski i nie ma "maxLength" maksymalnie można wpisać 50 znaków
         disabled={!field.editable}
         type={htmlInputType}
         onKeyDown={handleOnKeyDown}
         onFocus={() => props.setHasInputFocused(true)}
         onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnInputChange(e.target.value)}
         onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => props.handleOnPaste && props.handleOnPaste(e)}
         onBlur={(e: React.FocusEvent) => {
            props.setHasInputFocused(false)
            props.handleOnBlur(e)
         }} 
      />
   )
})

export default InputNumber